export default __webpack_public_path__ + "static/media/noTemplate.30dd78f9.svg";